// Inline-SVG line chart for DAU/WAU/MAU. Three overlaid polylines, no chart
// library. `rows` is an array of { day, dau, wau, mau }.
const SERIES = [
  { key: 'dau', color: '#1c1917', label: 'DAU' },
  { key: 'wau', color: '#a16207', label: 'WAU' },
  { key: 'mau', color: '#9a3412', label: 'MAU' },
];

export function Sparkline({ rows, height = 80, showLegend = false }) {
  if (!rows || rows.length < 2) return null;
  const w = 720, pad = 4;
  const all = rows.flatMap((r) => SERIES.map((s) => r[s.key] ?? 0));
  const max = Math.max(1, ...all);
  const xStep = (w - pad * 2) / (rows.length - 1);
  return (
    <div>
      <svg viewBox={`0 0 ${w} ${height}`} className="w-full" style={{ height }}>
        {SERIES.map((s) => (
          <polyline
            key={s.key}
            fill="none"
            stroke={s.color}
            strokeWidth="1.5"
            points={rows
              .map((r, i) => {
                const x = pad + i * xStep;
                const y = height - pad - ((r[s.key] ?? 0) / max) * (height - pad * 2);
                return `${x},${y}`;
              })
              .join(' ')}
          />
        ))}
      </svg>
      {showLegend && (
        <div className="flex gap-3 text-xs text-stone-500 mt-1">
          {SERIES.map((s) => (
            <span key={s.key} className="inline-flex items-center gap-1">
              <span className="w-2 h-2 rounded-full" style={{ background: s.color }} />
              {s.label}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
